'use client'

import React from 'react'

type Props = {
    baseSide: number
    height: number
}

const WIDTH = 340
const HEIGHT = 220

export default function SquarePyramidChart({ baseSide, height }: Props) {
    const maxDim = Math.max(baseSide, height, 0.0001)
    const scale = 130 / maxDim
    const s = Math.max(baseSide * scale, 60)
    const h = Math.max(height * scale, 40)
    const ox = s * 0.42
    const oy = -s * 0.22

    const cx = WIDTH / 2
    const baseY = (HEIGHT + h) / 2 + 10
    const apex = [cx, baseY - oy / 2 - h]

    const FL = [cx - s / 2, baseY]
    const FR = [cx + s / 2, baseY]
    const BR = [cx + s / 2 + ox, baseY + oy]
    const BL = [cx - s / 2 + ox, baseY + oy]
    const baseCenter = [(FL[0] + BR[0]) / 2, (FL[1] + BR[1]) / 2]

    return (
        <svg width={WIDTH} height={HEIGHT} viewBox={`0 0 ${WIDTH} ${HEIGHT}`} style={{ maxWidth: '100%', height: 'auto' }}>
            {/* base parallelogram */}
            <polygon points={`${FL.join(',')} ${FR.join(',')} ${BR.join(',')} ${BL.join(',')}`} fill="#2563eb" opacity={0.12} stroke="#2563eb" strokeWidth={1.5} />
            {/* hidden edges */}
            <line x1={BL[0]} y1={BL[1]} x2={apex[0]} y2={apex[1]} stroke="#9ca3af" strokeWidth={1.5} strokeDasharray="4,3" />
            <line x1={BR[0]} y1={BR[1]} x2={apex[0]} y2={apex[1]} stroke="#9ca3af" strokeWidth={1.5} strokeDasharray="4,3" />
            {/* visible faces */}
            <polygon points={`${FL.join(',')} ${FR.join(',')} ${apex.join(',')}`} fill="#2563eb" opacity={0.28} stroke="#2563eb" strokeWidth={2} />
            <polygon points={`${FR.join(',')} ${BR.join(',')} ${apex.join(',')}`} fill="#2563eb" opacity={0.18} stroke="#2563eb" strokeWidth={2} />
            <line x1={FL[0]} y1={FL[1]} x2={apex[0]} y2={apex[1]} stroke="#2563eb" strokeWidth={2} />
            {/* height marker */}
            <line x1={baseCenter[0]} y1={baseCenter[1]} x2={apex[0]} y2={apex[1]} stroke="#16a34a" strokeWidth={1.5} strokeDasharray="4,3" />
            <text x={apex[0] + 8} y={(baseCenter[1] + apex[1]) / 2} fontSize={11} fill="#16a34a">h = {height.toFixed(2)}</text>
            {/* base label */}
            <text x={(FL[0] + FR[0]) / 2} y={FL[1] + 20} fontSize={11} textAnchor="middle" fill="#dc2626">b = {baseSide.toFixed(2)}</text>
        </svg>
    )
}
